export default "__VITE_ASSET__CjBCIFFX__"